import numeral from 'numeral'
import VueI18n from 'vue-i18n'
import _ from 'lodash'

/*
  cookie
*/
var getCookie = function (cname) {
  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

var setCookie = function (cname, cvalue, exdays) {
  var d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

var delCookie = function (cname) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(cname)
  if (cval != null) { document.cookie = cname + '=' + cval + ';expires=' + exp.toGMTString() }
}

/*
  localStorage
*/
var setWithExpiry = function (key, value, ttl) {
  const now = new Date()
  const item = {
    value: value,
    expiry: now.getTime() + ttl
  }
  localStorage.setItem(key, JSON.stringify(item))
}

var getWithExpiry = function (key) {
  const itemStr = localStorage.getItem(key)
  if (!itemStr) {
    return null
  }
  const item = JSON.parse(itemStr)
  const now = new Date()
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key)
    return null
  }
  return item.value
}

// 度 -> 度分秒
var handleDtoDMS = function (d, type) {
  var D = null; var M = null; var S = null; var Abridge
  if ((type == 'LON' && d <= 180) || (type == 'LAT' && d <= 90)) {
    if (type == 'LON') {
      Abridge = d < 0 ? 'W' : 'E'
    } else {
      Abridge = d < 0 ? 'S' : 'N'
    }
    d = Math.abs(d)
    D = parseInt(d)

    const m_temp = parseFloat((d - D) * 60)
    M = parseInt(m_temp)
    S = Math.round((m_temp - M) * 60)
  }
  return {
    d: D,
    m: M,
    s: S,
    abridge: Abridge
  }
}

// 度 -> 度分
var handleDtoDM = function (d, type) {
  var D = null; var M = null; var S = null; var Abridge
  if ((type == 'LON' && d <= 180) || (type == 'LAT' && d <= 90)) {
    if (type == 'LON') {
      Abridge = d < 0 ? 'W' : 'E'
    } else {
      Abridge = d < 0 ? 'S' : 'N'
    }
    d = Math.abs(d)
    D = parseInt(d)
    M = Math.round(parseFloat((d - D) * 60))
  }
  return {
    d: D,
    m: M,
    abridge: Abridge
  }
}

// 度分 => 度
var handleDMtoD = function (d, m, abridge, type) {
  var D = null
  if ((type == 'LON' && d < 180 && m < 60) ||
    (type == 'LAT' && d < 90 && m < 60)) {
    D = parseFloat(d) + parseFloat(m / 60)
    D = _.round(D, 5)
    if (abridge == 'W' || abridge == 'S') {
      D = ~D
    }
  }
  return {
    d: D
  }
}

// 度分 => 度分秒
var handleDMtoDMS = function (d, m, abridge, type) {
  var D = null; var M = null; var S = null
  if ((type == 'LON' && d < 180 && m < 60) ||
    (type == 'LAT' && d < 90 && m < 60)) {
    D = d
    M = parseInt(m)
    // S = m == M ? 0 : parseFloat((m - M) * 60).toFixed(5)
    S = _.round((m - M) * 60, 5)
  }
  return {
    d: D,
    m: M,
    s: S
  }
}

// 度分秒 => 度
var handleDMStoD = function (d, m, s, abridge, type) {
  var D = null
  if ((type == 'LON' && d < 180 && m < 60 && s < 60) ||
    (type == 'LAT' && d < 90 && m < 60 && s < 60)) {
    D = parseFloat(d) + parseFloat(m / 60) + parseFloat(s / 3600)
    D = _.round(D, 5) // D.toFixed(5)
    if (abridge == 'W' || abridge == 'S') {
      D = ~D
    }
  }
  return {
    d: D
  }
}

// 度分秒 => 度分
var handleDMStoDM = function (d, m, s, abridge, type) {
  var D = null; var M = null
  if ((type == 'LON' && d < 180 && m < 60 && s < 60) ||
    (type == 'LAT' && d < 90 && m < 60 && s < 60)) {
    D = d
    M = _.round(parseFloat(m) + parseFloat(s / 60), 5)
  }
  return {
    d: D,
    m: M
  }
}

export default {
  getCookie,
  setCookie,
  delCookie,
  setWithExpiry,
  getWithExpiry,

  handleDtoDMS,
  handleDtoDM,
  handleDMtoD,
  handleDMtoDMS,
  handleDMStoD,
  handleDMStoDM
}
